<template>
  <b-row class="justify-content-center m-0 w-100">
    <b-col v-if="badgeInfo" class="container__badge-detail px-xl-0">
      <div class="mb-4 text__key-method">
        <div class="h5 font-weight-bold">Key Method</div>
        <div v-safe-html="badgeInfo.learning_unit.competency_how"></div>
      </div>

      <div v-if="badgeInfo.recommendation" class="accordion mb-4">
        <b-card class="card-box card__recommendation">
          <b-card-header
            header-tag="header"
            class="justify-content-between card__header-recommendation"
            role="tab"
          >
            <div class="h5 font-weight-bold m-0">Assessor's recommendation</div>
            <b-button
              class="p-0"
              variant="link"
              :aria-expanded="visible ? 'true' : 'false'"
              :aria-controls="`recommendation`"
              style="width: auto; border: none"
              @click="visible = !visible"
              >{{ visible ? 'Hide' : 'Show' }}</b-button
            >
          </b-card-header>

          <b-collapse
            id="recommendation"
            v-model="visible"
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <div v-safe-html="badgeInfo.recommendation"></div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <div v-if="evidenceSubmission">
        <learning-unit-score-description-card
          v-if="learningUnit.score_description"
          :learning-unit="learningUnit"
          class="mb-4"
        />

        <post-evaluation-assessment-part
          v-for="(partMeta, index) in partMetaData"
          :key="`card__part-${index + 1}-task-list`"
          class="mb-3"
          :part="partMeta"
          :learning-unit="learningUnit"
          :post-ids="partPostIds[partMeta] ? partPostIds[partMeta] : []"
          :editable="false"
          submittable
          assessable
          :evidence-submission="evidenceSubmission"
          disabled
          readonly
          collapse
          :hide-comment="!badgeInfo.show_feedback"
        >
        </post-evaluation-assessment-part>
      </div>

      <div
        v-if="
          badgeInfo.show_feedback && evidenceSubmission && evidenceSubmission.feedback_for_earner
        "
      >
        <b-card no-body class="card-box mb-4 card__feedback-for-earner">
          <b-card-body class="pt-3">
            <div>
              <div class="font-weight-bold mb-1 title__feedback-for-earner mb-3">
                Feedback for Earner
              </div>

              <div
                v-safe-html="evidenceSubmission.feedback_for_earner"
                class="border border-medium rounded p-3 text-pre-wrap text__feedback-for-earner bg-secondary"
              ></div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-col>
  </b-row>
</template>
<script>
import { usePostExtractor } from '@/composables/usePostExtractor';
import { datetimeMixin } from '@/mixins/datetimeMixin';
import PostEvaluationAssessmentPart from '@/components/Post/PostEvaluationAssessmentPart';
import Post from '@/models/Post';
import EvidenceSubmission from '@/models/EvidenceSubmission';
import LearningUnit from '@/models/LearningUnit';
import LearningUnitScoreDescriptionCard from '@/components/LearningUnit/LearningUnitScoreDescriptionCard';

export default {
  components: {
    PostEvaluationAssessmentPart,
    LearningUnitScoreDescriptionCard
  },
  mixins: [datetimeMixin],

  props: {
    badgeInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      isLoading: false,
      visible: true
    };
  },

  computed: {
    code() {
      return this.$route.params.code;
    },

    partMetaData() {
      return Object.keys(Post.PART);
    },

    partPostIds() {
      const { extractPostIdGroupByPart } = usePostExtractor();

      const {
        badgeInfo: { posts = [] }
      } = this;

      return posts.length ? extractPostIdGroupByPart(posts) : {};
    },

    learningUnit() {
      return this.badgeInfo.learning_unit
        ? LearningUnit.find(this.badgeInfo.learning_unit.id)
        : null;
    },

    evidenceSubmission() {
      return this.badgeInfo.evidence_submission
        ? EvidenceSubmission.find(this.badgeInfo.evidence_submission.id)
        : null;
    }
  },

  methods: {
    viewBadge(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.text__key-method,
.card__recommendation,
.container__badge-detail,
.card__feedback-for-earner {
  max-width: 910px;
  margin: auto;
}

.card__recommendation {
  border-radius: 10.4px !important;
}
.card__header-recommendation {
  padding: 1rem 1.25rem !important;
  border-bottom: 1px solid rgba(122, 123, 151, 0.3) !important;
}

.container__badge-detail {
  padding: 0 32px;
}

@media screen and (max-width: 375px) {
  .container__badge-detail {
    padding: 0 16px;
  }
}
</style>
